/**
 * User roles for role-based access control
 */
export enum UserRole {
  USER = 'user',
  PARTNER = 'partner',
  ADMIN = 'admin',
}

/**
 * User profile interface matching Firestore schema
 */
export interface UserProfile {
  id: string;
  email: string;
  displayName: string | null;
  phoneNumber: string | null;
  role: UserRole;
  emailVerified: boolean;
  phoneVerified: boolean;
  createdAt: Date;
  updatedAt: Date;
  // Optional fields
  photoURL?: string | null;
  locationId?: string | null; // For partners
  preferences?: UserPreferences;
}

/**
 * User preferences stored in user profile
 */
export interface UserPreferences {
  theme?: 'light' | 'dark' | 'system';
  language?: string;
  notifications?: {
    email?: boolean;
    push?: boolean;
    sms?: boolean;
  };
}

/**
 * Authentication state
 */
export interface AuthState {
  user: UserProfile | null;
  isLoading: boolean;
  isAuthenticated: boolean;
}

